export const DriversLicenseCardNumberConfig = {
  ACT: {
    maskPattern: {
      mask: 'AAAAAAAAAA',
    },
    config: [
      {
        slug: 'pattern',
        configContext: { pattern: '^[A-Za-z0-9]{5,10}$' },
      },
    ],
  },
  NSW: {
    maskPattern: {
      mask: '0000000000',
    },
    config: [
      {
        slug: 'pattern',
        configContext: { pattern: '^[A-Za-z0-9]{5,10}$' },
      },
    ],
  },
  NT: {
    maskPattern: {
      prefix: '13',
      mask: '00000000',
    },
    config: [
      {
        slug: 'pattern',
        configContext: { pattern: '^[A-Za-z0-9]{5,10}$' },
      },
    ],
  },
  WA: {
    maskPattern: {
      mask: 'AAAAAAAAAA',
    },
    config: [
      {
        slug: 'pattern',
        configContext: { pattern: '^[A-Za-z0-9]{5,10}$' },
      },
    ],
  },
  SA: {
    maskPattern: {
      mask: 'AAAAAAAAA',
    },
    config: [
      {
        slug: 'pattern',
        configContext: { pattern: '^[A-Za-z0-9]{5,10}$' },
      },
    ],
  },
  TAS: {
    maskPattern: {
      mask: 'AAAAAAAAA',
    },
    config: [
      {
        slug: 'pattern',
        configContext: { pattern: '^[A-Za-z0-9]{5,10}$' },
      },
    ],
  },
  QLD: {
    maskPattern: {
      mask: 'AAAAAAAAAA',
    },
    config: [
      {
        slug: 'pattern',
        configContext: { pattern: '^[A-Za-z0-9]{5,10}$' },
      },
    ],
  },
  VIC: {
    maskPattern: {
      mask: 'AAAAAAAA',
    },
    config: [
      {
        slug: 'pattern',
        configContext: { pattern: '^[A-Za-z0-9]{5,10}$' },
      },
    ],
  },
};
